// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemDetails_wrapper__lIY2B","items-container":"ItemDetails_items-container__M5zaE"};